import fetcher from '../utils/api';

const desktopService = {
  getDesktopVersion: async () => fetcher('desktop_version/', 'GET', false)
};

export default desktopService;
